import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { SessionContext } from '../../context/Session';
import Typography from '@mui/material/Typography';

export default function AddressForm({ type }) {
  const { shipping, setShipping } = React.useContext(SessionContext);
  const [email, setEmail] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [addressLine1, setAddressLine1] = React.useState('');
  const [addressLine2, setAddressLine2] = React.useState('');
  const [city, setCity] = React.useState('');
  const [state, setState] = React.useState('');
  const [zipCode, setZipCode] = React.useState('');
  React.useEffect(() => {
    const shippingData = {
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      city,
      state,
      zipCode,
      email,
      phoneNumber,
    };
    setShipping(shippingData);
  }, [
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    state,
    zipCode,
    email,
    phoneNumber,
  ]);

  return (
    <Box sx={{ borderTop: 1, mt: 2, pt: 2 }}>
      <Typography variant='primary' sx={{ mt: 5 }}>
        Shipping / Contact Info
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            onChange={(event) => {
              setFirstName(event.target.value);
            }}
            required
            id='firstName'
            name='firstName'
            label='First name'
            fullWidth
            autoComplete='given-name'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            onChange={(event) => {
              setLastName(event.target.value);
            }}
            required
            id='lastName'
            name='lastName'
            label='Last name'
            fullWidth
            autoComplete='family-name'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            onChange={(event) => {
              setAddressLine1(event.target.value);
            }}
            required
            id='address1'
            name='address1'
            label='Address'
            fullWidth
            autoComplete='shipping address-line1'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            onChange={(event) => {
              setCity(event.target.value);
            }}
            required
            id='city'
            name='city'
            label='City'
            fullWidth
            autoComplete='shipping address-level2'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            onChange={(event) => {
              setState(event.target.value);
            }}
            required
            id='state'
            name='state'
            label='State/Province/Region'
            fullWidth
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            onChange={(event) => {
              setZipCode(event.target.value);
            }}
            required
            id='zip'
            name='zip'
            label='Zip / Postal code'
            fullWidth
            autoComplete='shipping postal-code'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            required
            id='email'
            name='email'
            label='Email Address'
            fullWidth
            autoComplete='email'
            variant='standard'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            onChange={(event) => {
              setPhoneNumber(event.target.value);
            }}
            required
            id='phone'
            name='phone'
            label='Phone Number'
            fullWidth
            autoComplete='phone'
            variant='standard'
          />
        </Grid>
      </Grid>
    </Box>
  );
}
